/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import { FC } from "react";
import { toAbsoluteUrl } from "../../helpers";
import { useLang, setLanguage } from "../../i18n/Metronici18n";
import { useIntl } from "react-intl";

const AuthLayoutLanguages: FC = () => {
  const intl = useIntl();
  const languages = [
    {
      lang: "pt",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.PTBR",
      })}`,
      flag: toAbsoluteUrl("/media/flags/brazil.svg"),
    },
    {
      lang: "en",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.ENGLISH",
      })}`,
      flag: toAbsoluteUrl("/media/flags/united-states.svg"),
    },
    {
      lang: "es",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.SPANISH",
      })}`,
      flag: toAbsoluteUrl("/media/flags/spain.svg"),
    },
    {
      lang: "it",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.ITALIAN",
      })}`,
      flag: toAbsoluteUrl("/media/flags/italy.svg"),
    },
    {
      lang: "hr",
      name: `${intl.formatMessage({
        id: "MENU.HEADER.USERMENU.LANGUAGES.CROATIAN",
      })}`,
      flag: toAbsoluteUrl("/media/flags/croatia.svg"),
    },
  ];

  const lang = useLang();
  const currentLanguage = languages.find((x) => x.lang === lang);
  return (
    <div className="dropdown">
      <button
        className="btn bg-light rounded text-primary fs-6 px-5 py-2 m-3"
        type="button"
        id="languageDropdown"
        data-bs-toggle="dropdown"
      >
        {currentLanguage?.name}
        <img
          className="w-20px h-20px rounded-1 ms-2"
          src={currentLanguage?.flag}
          alt="metronic"
        />
      </button>

      <div className="dropdown-menu mt-1 w-80    ">
        {languages.map((l) => (
          <button
            className={clsx(
              "dropdown-item d-flex justify-content-between text-primary",
              {
                active: l.lang === currentLanguage?.lang,
              }
            )}
            key={l.lang}
            onClick={() => {
              setLanguage(l.lang);
            }}
          >
            <span>{l.name}</span>
            <img
              className="w-20px h-20px rounded-1"
              src={l.flag}
              alt="metronic"
            />
          </button>
        ))}
      </div>
    </div>
  );
};

export { AuthLayoutLanguages };
